import TodoList from "./components/TodoList";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return(
    <div className="App">
       <TodoList></TodoList>
    </div>
  )
}


export default App;